import { css } from '@emotion/react'
import { ClickableIcomoonIcon } from '../../../../atoms/IcomoonIcon'
import { colors, Tooltip } from 'plume-ui'
import {
  GetCompanyMemoResult,
  Status,
  UsersResult,
} from '../../../../../types/api'

type Props = {
  text?: string
  shortName: string
  onClickEdit: (v: string) => void
  disabled: boolean
}

type Memo = {
  companyId: string
  companyMemo: GetCompanyMemoResult
  contactPerson: UsersResult
  status: Status
}

export const Memo = ({ text, shortName, onClickEdit, disabled }: Props) => {
  const handleOnClick = () => {
    onClickEdit(shortName)
  }

  return (
    <div
      className="memo-area"
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      <span
        css={css`
          margin-left: 8px;
          margin-right: 4px;
          white-space: normal;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          width: 300px;
          line-height: 150%;
          word-break: break-word;
        `}
        title={text}
      >
        {text}
      </span>
      {!disabled && (
        <Tooltip label="メモを編集" id="memo">
          <span
            className="edit-icon"
            data-for="memo"
            css={css`
              width: 20px;
              height: 20px;
              margin-left: 4px;
              margin-right: 4px;
              display: block;
              visibility: hidden;
              :hover {
                background-color: rgba(0, 0, 0, 0.08);
                border-radius: 50%;
              }
              align-items: center;
              position: relative;
            `}
          >
            <ClickableIcomoonIcon
              name="pen-fill"
              onClick={handleOnClick}
              css={css`
                display: block;
                font-size: 14px;
                color: ${colors.textLight};
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                cursor: pointer;
              `}
            />
          </span>
        </Tooltip>
      )}
    </div>
  )
}
